import Vue from 'vue'
import Router from 'vue-router'
import './components/Login.vue'
Vue.use(Router)

export default new Router({
    // mode: 'history',
    // history:true,
    base: process.env.BASE_URL,
    // base: '/servicios',

    routes: [
        {
            path: '/',
            name: 'home',

            beforeEnter: (to, from, next) => {
                next('servicios')
            }
        },
        {
            path: '/servicios',
            name: 'servicios',
            component: () => import('./components/exodus/servicios.vue'),
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: '/servicios/en-usa',
            name: 'servicios',
            component: () => import('./components/exodus/services.vue'),
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: '/servicios/:id',
            name: 'servicios',
            component: () => import('./components/exodus/servicio.vue'),
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: '/servicios/en-usa/:id',
            name: 'servicios',
            component: () => import('./components/exodus/service.vue'),
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: '/terminos_condiciones',
            name: 'terminos_condiciones',
            component: () => import('./components/exodus/terminos_condiciones.vue'),
            beforeEnter: (to, from, next) => {
                next('terminos_condiciones')
            }
        },
        {
            path: '/contacto',
            name: 'servicios',
            component: () => import('./components/exodus/contacto.vue'),
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: '/aviso_privacidad',
            name: 'servicios',
            component: () => import('./components/exodus/aviso_privacidad.vue'),
            beforeEnter: (to, from, next) => {
                next()
            }
        },
    ]
})
